module.exports = __webpack_public_path__ + "img/lomexin-1.8eda2975.png";